import React from 'react'

import { Account } from '@pages/Trade/types'

import { Body2 } from '@ui/Typography'
import { CaretIcon } from '@ui/icons/Caret.icon'
import { TradingViewIcon } from '@ui/icons/platforms/TradingView.icon'

import { useWindowResize } from '@utils/domUtils'

import { useTradingViewTradeButton } from '../hooks/useTradingViewTradeButton'

import styles from './TradingViewTradeButton.module.scss'

type TradingViewTradeButtonProps = {
  account: Account
}

export const TradingViewTradeButton: React.FC<TradingViewTradeButtonProps> = ({ account }) => {
  const isMobile = useWindowResize()
  const { isLoading, handleClick } = useTradingViewTradeButton({ account })

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.tradingViewIconButton}
        onClick={handleClick}
        role='button'
        aria-disabled={isLoading}
      >
        <TradingViewIcon size={isMobile ? 40 : 32} />
        <Body2 medium color='text-inverse-black-neutral' className={styles.tradingViewText}>
          Trade on TradingView
        </Body2>
        <CaretIcon.Right size={16} color='text-inverse-black-neutral' />
      </div>
    </div>
  )
}
